import PopoverSystem from './PopoverSystem';
import './PopoverSystem.scss';

export default PopoverSystem;
